import { Checkbox, Flex, Form, Input, Select } from 'antd';

const { Item } = Form;

const FraudTemplateFields = ({ fraudTemplateForm, testIdPrefix = '' }) => {
  const prefix = testIdPrefix ? `${testIdPrefix}-` : '';

  return (
    <>
      <Item
        name="createFraudSticky"
        valuePropName="checked"
        style={{ marginBottom: 'var(--spacing-xs)' }}
      >
        <Checkbox
          data-testid={`${prefix}create-fraud-sticky-checkbox`}
          onChange={(e) =>
            fraudTemplateForm.onFraudStickyChange(e.target.checked)
          }
        >
          Create Fraud Sticky
        </Checkbox>
      </Item>
      {fraudTemplateForm.createFraudSticky && (
        <Flex
          gap="var(--spacing-xs)"
          style={{ marginBottom: 'var(--spacing-md)' }}
        >
          <Item
            name="fraudType"
            label="Fraud Type"
            style={{ marginBottom: 0, flex: 1 }}
          >
            <Select
              data-testid={`${prefix}fraud-type-select`}
              placeholder="Select fraud type (optional)"
              onChange={fraudTemplateForm.onFraudTypeChange}
              allowClear
              options={fraudTemplateForm.templates.map((template) => ({
                label: template.label,
                value: template.name,
              }))}
            />
          </Item>
          <Item label="Incident #" style={{ marginBottom: 0, flex: 1 }}>
            <Input
              data-testid={`${prefix}incident-number-input`}
              placeholder="Optional"
              value={fraudTemplateForm.incidentNumber}
              onChange={fraudTemplateForm.onIncidentChange}
              disabled={!fraudTemplateForm.selectedFraudType}
            />
          </Item>
        </Flex>
      )}
    </>
  );
};

export default FraudTemplateFields;
